import { useState } from 'react';
import ManageShell, { type ManageMenuGroup } from '../manage-common/ManageShell';
import { getUserSession } from '../screens/login/userSession';
import ManageDashboard from './dashboard/ManageDashboard';
import ManageWorship from './worship/ManageWorship';
import ManageNews from './news/ManageNews';
import ManageSchedule from './schedule/ManageSchedule';
import ManageSermon from './sermon/ManageSermon';
import ManageNotification from './notification/ManageNotification';
import ManageGallery from './gallery/ManageGallery';
import ManageChurchProfile from './church-profile/ManageChurchProfile';
import ManageStaffApproval from './staff-approval/ManageStaffApproval';

// 교회앱관리: 성도용 앱 콘텐츠 + 담당자 계정 관리. 교적·심방·출석은 /manage-roll, 재정은 /manage-finance.
type MenuKey =
  | 'dashboard'
  | 'worship'
  | 'news'
  | 'schedule'
  | 'sermon'
  | 'notification'
  | 'gallery'
  | 'churchProfile'
  | 'staffApproval';

function buildMenuGroups(isSuperAdmin: boolean): ManageMenuGroup<MenuKey>[] {
  return [
    {
      group: '홈',
      items: [{ key: 'dashboard', label: '대시보드', icon: '🏠' }],
    },
    {
      group: '콘텐츠 관리',
      items: [
        { key: 'worship', label: '예배순서', icon: '📋' },
        { key: 'news', label: '교회소식', icon: '📢' },
        { key: 'schedule', label: '교회일정', icon: '🗓' },
        { key: 'sermon', label: '설교영상', icon: '🎬' },
        { key: 'gallery', label: '갤러리', icon: '🖼' },
      ],
    },
    {
      group: '운영',
      items: [
        { key: 'notification', label: '알림보내기', icon: '✉️' },
        { key: 'churchProfile', label: '교회정보', icon: '⛪' },
      ],
    },
    ...(isSuperAdmin
      ? [
          {
            group: '관리자',
            items: [{ key: 'staffApproval' as const, label: '승인관리', icon: '🛡️' }],
          },
        ]
      : []),
  ];
}

export default function Manage() {
  const [activeMenu, setActiveMenu] = useState<MenuKey>('dashboard');

  return (
    <ManageShell<MenuKey>
      console="app"
      menuGroups={buildMenuGroups(getUserSession('app')?.role === 'super')}
      activeMenu={activeMenu}
      onSelectMenu={setActiveMenu}
    >
      {(session) => (
        <>
          {activeMenu === 'dashboard' && <ManageDashboard authChurch={session.authChurch} requesterId={session.id} />}
          {activeMenu === 'worship' && <ManageWorship authChurch={session.authChurch} />}
          {activeMenu === 'news' && <ManageNews authChurch={session.authChurch} />}
          {activeMenu === 'schedule' && <ManageSchedule authChurch={session.authChurch} />}
          {activeMenu === 'sermon' && <ManageSermon authChurch={session.authChurch} />}
          {activeMenu === 'notification' && <ManageNotification authChurch={session.authChurch} />}
          {activeMenu === 'gallery' && <ManageGallery authChurch={session.authChurch} />}
          {activeMenu === 'churchProfile' && <ManageChurchProfile authChurch={session.authChurch} />}
          {activeMenu === 'staffApproval' && session.role === 'super' && (
            <ManageStaffApproval authChurch={session.authChurch} requesterId={session.id} />
          )}
        </>
      )}
    </ManageShell>
  );
}
